<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/signaletiquePour
</style>

<template>
    <div class="g_signaletiquePour">
        <Paragraph
            :content="$json.hero.content"
            size="L" />
        <ul class="">
            <li
                v-for="(item, index) in $json.hero.list"
                :key="index">
                <Heading
                    :level="2"
                    v-html="item"
                    fake />
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'SignaletiquePour'
}
</script>
